import { ErrorMessage, Field, Formik } from 'formik'
import React from 'react'
import RadioButtonGroup from '../forms/fields/RadioButtonGroup'
import RadioButtonWrapper from '../forms/fields/RadioButtonWrapper'
import FieldWrapper from '../forms/FieldWrapper'
import Translation from '../Translation/cont/Translation'
import config from '../../config.json'
import MultiselectCheckboxCinemas from '../forms/fields/MultiselectCheckboxCinemas'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import getDisabledClass from '../../functions/getDisabledClass'
import OverlaySubmitCancelButtons from '../overlay/presentational/OverlaySubmitCancelButtons'

const EditSelection = ({initValues, selectionId, validationSchema, editSelectionSettings, editSelectionAutoplay, cliCinemas, cliCinemasIdList, styleOptions, editDisabled, onSubmit, onCancel}) => {
    return (
        <Formik
            initialValues={sanitizeFormInput(initValues)}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
                if(editDisabled) {
                    return false
                }

                onSubmit(sanitizeFormOutput(values))
                actions.setSubmitting(false);
                onCancel()
            }}
        >
            {({values, handleSubmit}) => (
                <form 
                    className="overlay-form edit-selection-settings"
                    onSubmit={handleSubmit}
                >                
                    <div className="left-sections">
                        <FieldWrapper label={<Translation id="content_title"/>} id="title" classes="field-text gap-20">
                            <Field type="text" name="title" id="title" className="text-regular input-text-box" />
                            <ErrorMessage name="title" component="div" /> 
                        </FieldWrapper>

                        <p>Element ID: {selectionId && selectionId}</p>

                        {_.has(values, "cinema") && cliCinemas ? (
                            cliCinemasIdList.length > 1 ? (
                                <fieldset className="field-cinemas">
                                        <legend className="field-text-label"><Translation id="content_cinemas"/></legend>                                                
                                        <div className="select-all-cinemas-button-wrapper">  
                                            <div key={'field-all'} className="field-checkbox">
                                                <Field 
                                                    key={'all'} 
                                                    attrid={'all'}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={'alle anwählen'}
                                                    clicinemas={'all'}
                                                    value={cliCinemasIdList} 
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-container">
                                            {cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema

                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </fieldset>
                                ) : (
                                    cliCinemasIdList.map(cinemaId => {
                                        const cinema = cliCinemas[cinemaId]
                                        const {pk, nameShort} = cinema
                                        
                                        return (
                                            <div key={'field' + pk} className="field-checkbox">
                                                <Field 
                                                    key={pk} 
                                                    attrid={pk}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={nameShort}
                                                    clicinemas={cliCinemas}
                                                    value={pk} 
                                                />
                                            </div>
                                        )
                                    })
                                )
                            ) : (
                                ''
                            )
                        }
                        {editSelectionSettings &&
                        <>
                            <RadioButtonGroup
                                label={<Translation id="selection_style_choose_label"/>}
                                description={<Translation id="selection_style_description"/>}
                                className="select-new-style-type"
                            >
                                <ErrorMessage className="text-regular-color movie-error" name="style" component="div" /> 

                                {styleOptions.map(({transId, id}) => (
                                    <RadioButtonWrapper 
                                        key={id} 
                                        id={id} 
                                        label={<Translation id={transId}/>}
                                    >
                                        <Field
                                            id={id}
                                            type="radio"
                                            name="style"
                                            value={id}
                                        />

                                    </RadioButtonWrapper>
                                ))}
                            </RadioButtonGroup>

                            {editSelectionAutoplay && <RadioButtonGroup
                                label={<Translation id="selection_trailer_autoplay_label"/>}
                                description=""
                                className="select-new-section-type"
                            >
                                <ErrorMessage className="text-regular-color movie-error" name="trailerAutoplay" component="div" /> 

                                {config.sectionSettings.autoplayTypes.map(({transId, id}) => (
                                    <RadioButtonWrapper
                                        key={id} 
                                        id={id} 
                                        label={<Translation id={transId}/>}
                                    >
                                        <Field
                                            id={id}
                                            type="radio"
                                            name="trailerAutoplay"
                                            value={id}
                                        />
                                    </RadioButtonWrapper>

                                ))}
                            </RadioButtonGroup>}
                        </>
                        }
                    </div>

                    <OverlaySubmitCancelButtons
                        editDisabled={editDisabled}
                        onClose={onCancel}
                    />
                    
                </form>
            )}
        </Formik>
    );
}

export default EditSelection